'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setDragModifierKeys = undefined;

var _dragModifierKeysConstants = require('./dragModifierKeysConstants');

var setDragModifierKeys = exports.setDragModifierKeys = function setDragModifierKeys(modifierKeys) {
    return {
        type: _dragModifierKeysConstants.DRAG_MODIFIER_KEYS_SET,
        modifierKeys: modifierKeys
    };
}; // Constants


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/modifierKeys/dragModifierKeysActions.js
// module id = 2121
// module chunks = 0